const K = 32; // Standard K-factor
const DEFAULT_RATING = 1000;

/**
 * Calculate new ELO ratings for two players after a game.
 * Returns [newRatingA, newRatingB].
 *
 * @param ratingA - Player A's current rating
 * @param ratingB - Player B's current rating
 * @param result - 1 = A wins, 0 = B wins, 0.5 = draw
 */
export function calculateElo(
  ratingA: number = DEFAULT_RATING,
  ratingB: number = DEFAULT_RATING,
  result: 1 | 0 | 0.5
): [number, number] {
  const expectedA = 1 / (1 + Math.pow(10, (ratingB - ratingA) / 400));
  const expectedB = 1 - expectedA;

  const newA = Math.round(ratingA + K * (result - expectedA));
  const newB = Math.round(ratingB + K * ((1 - result) - expectedB));

  return [newA, newB];
}

export { DEFAULT_RATING };
